import 'css-chunksrc/feature/cash-bank/CashBankEditStartingAmount.module.scss';export default {
  "noWrap": "CashBankEditStartingAmount_noWrap"
};